import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AUTH_BASE_URL } from '../../auth-base-url.token';
import { RoleResponseDto } from '../../schemas/user-manager/role-response.dto';

@Injectable({ providedIn: 'root' })
export class UserManagerApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUTH_BASE_URL)}/userManager`;

    getRoles() {
        return this.builder
            .url(`${this.controllerUrl}/listRoles`)
            .get()
            .json<RoleResponseDto[]>()
            .build()
            .send();
    }
}
